import React, { useState } from "react";
import ToolWishlist from "./ToolWishlist";
import BlogWishlist from "./BlogWishlist";

const Wishlist = () => {
  const [activeTab, setActiveTab] = useState("Tools");

  return (
    <div className="h-screen flex flex-col text-white">
      {/* Tab buttons */}
      <div className="flex justify-center space-x-4 p-4 bg-gray-800">
        <button
          onClick={() => setActiveTab("Tools")}
          className={`px-4 py-2 rounded ${
            activeTab === "Tools" ? "bg-blue-500" : "bg-gray-600"
          }`}
        >
          Tools
        </button>
        <button
          onClick={() => setActiveTab("Blogs")}
          className={`px-4 py-2 rounded ${
            activeTab === "Blogs" ? "bg-blue-500" : "bg-gray-600"
          }`}
        >
          Blogs
        </button>
      </div>

      {/* Active component */}
      <div className="flex-grow p-4 bg-gray-900">
        {activeTab === "Tools" ? <ToolWishlist /> : <BlogWishlist />}
      </div>
    </div>
  );
};

export default Wishlist;
